import { Calendar } from "antd";
import { CorrectiveAction } from "src/pages/ActionPlan/Edit/CorrectiveAction";
import { Suppliers } from "src/pages/Procedure/Edit/StepEditModal/shared-components/Suppliers";
import StockControl from "src/pages/Product/Edit/StockControl";

export const keys = {
  authorization: "AUTHORIZATION",
};

export const defaultPageSize = 25;

export const filterOptions = {
  startsWith: { label: "Starts with", value: "StartsWith" },
  contains: { label: "Contains", value: "Contains" },
  isNotNull: { label: "Is not null", value: "IsNotNull" },
  equals: { label: "Equals", value: "Equals" },
  notEquals: { label: "Not Equals", value: "NotEquals" },
  lessThanEqual: { label: "Less then equal", value: "LessThanEqual" },
  greaterThanEqual: { label: "Greater than equal", value: "GreaterThanEqual" },
  greaterThan: { label: "Greater than", value: "GreaterThan" },
};

export const stateList = [
  {
    label: "ACT",
    value: "ACT",
  },
  {
    label: "NSW",
    value: "NSW",
  },
  {
    label: "NT",
    value: "NT",
  },
  {
    label: "QLD",
    value: "QLD",
  },
  {
    label: "SA",
    value: "SA",
  },
  {
    label: "TAS",
    value: "TAS",
  },
  {
    label: "VIC",
    value: "VIC",
  },
  {
    label: "WA",
    value: "WA",
  },
  {
    label: "OTH",
    value: "OTh",
  },
];

export const salaryModes = [
  {
    label: "Annually",
    value: "1",
  },
  {
    label: "Hourly",
    value: "2",
  },
];

export const localStorageKeys = {
  user: "a3j3d$s",
  authorization: "s7asl3de2",
  reportApiAuthorization: "",
};

export const CRMEntityTypes = {
  Company: 1,
  Individual: 2,
  Employee: 3,
  Contact: 4,
};

export const userTypes = {
  user: "USER",
  admin: "ADMIN",
  superAdmin: "SUPER_ADMIN",
};

export const DocStatusMap = {
  Approved: "Approved",
  AwaitingApproval: "Awaiting Approval",
  Rejected: "Rejected",
};

export const ProcedureStatusMap = {
  verifed: "Approved",
  verifiyNeeded: "To Be Approved",
};

export const FrequencyMap = {
  WhenVerChange: "When Version Changes",
  WeeklyWhenVerChange: "Weekly or When Version Changes",
  MonthlyWhenVerChange: "Monthly or When Version Changes",
  AnnuallyWhenVerChange: "Annually or When Version Changes",
  Every2YearsWhenVerChange: "Every 2 Years or When Version Changes",
  Every3YearsWhenVerChange: "Every 3 Years or When Version Changes",
};
export const ModuleNameMap = {
  ProceduresCALists: "Lists",
  ProceduresProcedures: "Checks",
  ProceduresViewCompletedProcedures: "View Completed Checks",
  ProceduresDocuments: "Documents",
  ProceduresInProgressChecks: "In Progress Checks",
  ProceduresProceduresReport: "Checks Report",
  ProceduresSheets: "Tabs",
  CorrectiveActionsCorrectiveActionsList: "NC List",
  CorrectiveActionsChecklists: "Checklists",
  CorrectiveActionsExceptions: "NC",
  CorrectiveActionsCorrectiveActionReports: "Non Conformance Reports",
  CorrectiveActionsOverdueCAsReports: "Overdue NC Reports",
  CorrectiveActionsActionTakenList: "Action Taken List",
  CorrectiveActionsComplaints: "Complaints",
  SupplierComplaints: "Supplier Complaints",
  CustomerComplaints: "Customer Complaints",
  CorrectiveActionsIncident: "Incident",
  CorrectiveActionsAccident: "Accident",
  LocationsLocationsOrCCPs: "Locations / Items",
  LocationsRackLocations: "Rack Locations",
  CalendarEvents: "Events",
  CalendarCalendarReports: "Calendar Reports",
  CalendarToDoList: "To Do List",
  DocumentationDocumentChangeManagement: "Document Change Management",
  DocumentationTastePanel: "Taste Panel",
  DocumentationDocuments: "Documents",
  DocumentationCompliants: "Complaints",
  DocumentationReturns: "Returns",
  DocumentationEmailHistory: "Email History",
  DocumentationMessageTool: "Message Tool",
  DocumentationTrainingRecords: "Training Records",
  DocumentationTrainingPacks: "Training Packs",
  TrainingTrainingCourses: "Training Courses",
  TrainingCompletedTrainingCourses: "Completed Courses",
  TrainingApprovalList: "Approval List",
  MaintenancePeople: "People",
  MaintenanceSettings: "Settings",
  MaintenanceOrganizations: "Organizations",
  MaintenanceDepartments: "Departments",
  MaintenanceDeviceManagement: "Device Management",
  MaintenanceVisitors: "Visitors",
  CautionsCautions: "Cautions",
  ProductsProducts: "Products",
  ProductsCategories: "Categories",
  ProductsFinishedProducts: "Finished Products",
  ProductsPricing: "Pricing",
  ProductsPicking: "Picking",
  HandsetGoodsInReceivedByDate: "Handset Goods In Received By Date",
  SuppliersSuppliers: "Suppliers",
  StockControlPurchaseOrder: "Purchase Order",
  SuppliersServiceCompanies: "Service Companies",
  SuppliersDeliveryBy: "Delivery By",
  CustomersCustomers: "Customers",
  StockControlSalesOrder: "Sales Order",
  ProceduresReportsTimeTaken: "Report Time Taken",
  ProceduresReportsStepValues: "Report Step Values",
  ProceduresReportsStepScore: "Report Step Score",
  ProceduresReportsProcedureScore: "Report Procedure Score",
  CorrectiveActionsReportsNumberOfCorrectiveActions:
    "Report Number Of Corrective Actions",
  LocationsReportsItem: "Report Items",
  ProductsReportsProducts: "Report Products",
  ProceduresReportsTally: "Report Tally",
  CorrectiveActionsReportsMostCommonCAsByStep: "Report Most Common CAs By Step",
  DocumentationReportsTrainingRecord: "Report Training Record",
  DocumentationReportsTastePanel: "Report Taste Panel",
  DocumentationReportsCompliant: "Complaints Report",
  ProductionReport: "Report Production",
  ProductionRecipes: "Recipes",
  ProductionViewCompletedRecipes: "Completed Recipes",
  ProductionInProgressRecipes: "In Progress Recipes",
  ProductionDowntimeReason: "Downtime Reason",
  GoodsInChecks: "Goods In",
  GoodsInCompletedChecks: "Completed Goods In",
  GoodsInProcessNewOrder: "Process New Order",
  GoodsInArchieveCompletedChecks: "Completed Archived Goods In",
  GoodsInDiscripencies: "View Discrepancies",
  GoodsInQuarantine: "Quarantine",
  GoodsInInProgress: "In Progress Goods In",
  AuditsChecks: "Audits",
  AuditsCompletedChecks: "Completed Audits By Site",
  AuditsCompletedBySupplier: "Completed Audits By Supplier",
  AuditsSites: "Sites",
  NearMissNearMiss: "Near Miss",
  AccidentAccidents: "Accidents",
  DispatchDispatch: "Dispatch",
  DispatchCompletedDispatch: "Completed Dispatches",
};
export const ModuleNameReverseMap = Object.entries(ModuleNameMap).reduce(
  (acc, [key, value]) => {
    acc[value] = key;
    return acc;
  },
  {} as Record<string, string>,
);
export const PortableModuleNameMap = {
  ProceduresProcedures: "All Checks",
  ProceduresUpcomingChecks: "Upcoming",
  ProceduresInProgressChecks: "In Progress",
  ProceduresCompletedChecks: "Completed",
  ProceduresSentChecks: "Sent",
  ProceduresAllocatedChecks: "Allocated",
  ProceduresTemplates: "Templates",
  ProceduresByLocation: "By Location",
  CorrectiveActionsAllCorrectiveActions: "All",
  CorrectiveActionsOutstanding: "Outstanding",
  CorrectiveActionsPending: "Pending",
  CorrectiveActionsResolved: "Resolved",
  CorrectiveActionsCreateNC: "Create NC",
  AccidentAccidents: "Accidents",
  IncidentIncidents: "Incidents",
  CautionsCreateCaution: "Create Caution",
  ComplaintsComplaints: "Complaints",
  StockControlGoodsIn: "Goods In",
  StockControlPutAway: "Put Away",
  StockControlQuarantine: "Quarantine",
  StockControlPicking: "Picking",
  StockControlStockCheck: "Stock Check",
  StockControlStockTransfer: "Stock Transfer",
  DispatchDispatch: "Dispatch",
  ProductsProducts: "Products",
  DocumentsDocuments: "Documents",
  ProductionRecipes: "Recipes",
  ProductionSalesOrder: "Sales Orders",
  TrainingTrainingCourses: "Training Courses",
  TrainingTrainingRecords: "Training Records",
  TrainingSignOff: "Sign Off",
  VisitorsVisitors: "Visitors",
  AuditsAudits: "Audits",
  AuditsUpcoming: "Upcoming",
  AuditsInProgress: "In Progress",
  AuditsCompleted: "Completed",
  AuditsSent: "Sent",
  CalendarCalendar: "Calendar",
  CalendarMissedEvents: "Missed Events",
  CalendarUpcoming: "Upcoming",
  CalendarHistory: "History",
  CalendarToDoList: "To Do List",
  SuppliersSuppliers: "Suppliers",
};

export const MenuGroupMap = {
  Calendar: "Calendar",
  Cautions: "Cautions",
  CorrectiveActions: "Non Conformances",
  Customers: "Customers",
  Documentation: "Documentation",
  Locations: "Locations",
  Maintenance: "Maintenance",
  Procedures: "Checks",
  Production: "Production",
  Products: "Products",
  Reports: "Reports",
  StockControl: "Stock Control",
  Suppliers: "Suppliers",
  Incident: "Incidents",
  Accident: "Accidents",
  Miscellaneous: "Miscellaneous",
  Complaints: "Complaints",
  Training: "Training",
  GoodsIn: "Goods In",
  Audits: "Audits",
  PurchaseOrders: "Purchase Orders",
  Accidents: "Accidents",
  NearMiss: "Near Miss",
  Dispatch: "Dispatch",
};

export const PortableDevicesGroupMap = {
  Procedures: "Checks",
  CorrectiveActions: "Non Conformances",
  Accident: "Accidents",
  Incident: "Incidents",
  Cautions: "Create Caution",
  Complaints: "Complaints",
  StockControl: "Stock Control",
  Dispatch: "Dispatch",
  Products: "Products",
  Documents: "Documents",
  Production: "Production",
  Training: "Training",
  Visitors: "Visitors",
  Audits: "Audits",
  Calendar: "Calendar",
  Suppliers: "Suppliers",
};
export const MenuGroupSequenceMap = {
  Calendar: 8,
  Cautions: 6,
  CorrectiveActions: 2,
  Customers: 16,
  Documentation: 9,
  Locations: 7,
  Maintenance: 19,
  Procedures: 1,
  Production: 17,
  Products: 11,
  Reports: 21,
  StockControl: 11,
  Suppliers: 13,
  Incident: 3,
  Miscellaneous: 20,
  // Complaints: 5,
  Training: 10,
  GoodsIn: 15,
  PurchaseOrders: 14,
  Audits: 18,
  // Accident: 20,
  Dispatch: 12,
  Visitors: 22,
  Accidents: 4,
  NearMiss: 5,
};
export const ModuleNameByTypeProcedure = {
  0: "Checks",
  1: "Goods In",
  2: "Recipe",
  3: "Checks",
  4: "Checks",
  5: "Training",
  6: "Checks",
  7: "Audit",
};
export const ComplaintDisplayNameMap = {
  ReportNumber: "Complaint No",
  CustomerComplaintNo: "Customer Complaint No",
  ReportedDate: "Reported Date/Time",
  ReportTakenBy: "Report Taken By",
  ComplainCost: "Complaint Cost (£)",
  CloseDownDateTime: "Close Down Time",
  BatchCodes: "Batch Code(s)",
  ProductDesc: "Product Description(s)",
  ProductCode: "Product Code(s)",
  ComplaintCodeId: "Complaint Category",
  Action: "Action Taken and Processing Details",
  ConclusionRemedialAction: "Conclusion and Remedial Actions",
  PreventativeAction: "Preventative Actions",
  RootCause: "Root Cause",
  Responsibility: "Responsibility(%)",
  Investigation: "Investigation",
  RiskAssessmentTimescale: "Resolve By (Date and Time)",
  CustomerNote: "Customer Name",
  CustomerCode: "Customer Code",
  CreatedBy: "User Name",
  ReceivedByMethod: "Receive By Method",
  DeliveryDate: "Delivery Date",
  ContactEmailAddress: "Contact Email Address",
  IsEmailSent: "Is Email Sent",
};

export const ExceptionDisplayNameMap: Record<any, string> = {
  TypeProcedure: "Type Procedure",
  ProcedureStepDescription: "Step Description",
  ExceptionType: "Exception Type",
  CorrectiveActionType: "NC Step",
  WorkRequestNo: "WRN",
  SCWorkRequestNo: "SNC",
  AssignTo: "Permitted User(s) to Manage NC",
  AssignedUser: "Assigned To",
  ResolveByDate: "Resolve By (Date & Time)",
  ExceptionMessage: "NC Message",
  ExceptionDate: "Exception Date",
  ExceptionCreateUser: "Created By",
  ExceptionPassUser: "Exception Pass By",
  ResolvedDate: "Resolved",
  ActionRequired: "Action Required",
  ActionTaken: "Preventative Actions Comments",
  ActionTakenListId: "Preventative Actions",
  AssessmentOfConsequences: "Assessment Of Consequences",
  CommentsTakenOnPC: "Web Comments",
  ExceptionImages: "NC Images",
  DateRange: "Date Range",
  FromDate: "From",
  ToDate: "To",
  LocationObjectId: "Location",
  RootCause: "Root Cause Additional Comments",
  RootCauseId: "Root Cause",
  StepNo: "Step No",
  IsSendEmail: "Send Email",
  EmailQueueStatus: "Email Status",
  ProductId: "Product Desc",
  ProductBatchCode: "Batch Code",
  ProductComment: "Product Comment",
  ShiftId: "Shift",
  OccurrenceTime: "Date / Time of Occurrence",
  SubNCId: "Sub NC",
  NCId: "NC",
  VerifiedById: "Verified By",
  VerifiedBy: "Verified By",
  CloseDownDateTime: "Date/Time Close Down",
  MarkSCExceptionFindingAsComplete: "OUR FINDINGS MARKED AS COMPLETED",
  IsSCExceptionFindingSkipped: "OUR FINDINGS SKIPPED",
  MarkSCExceptionActionAsComplete: "OUR ACTIONS MARKED AS COMPLETED",
  IsSCExceptionActionSkipped: "OUR ACTIONS SKIPPED",
  MarkSCExceptionSupplierInvestigationAsComplete:
    "SUPPLIER INVESTIGATION & RESPONSE MARKED AS COMPLETED",
  IsSCExceptionSupplierInvestigationSkipped:
    "SUPPLIER INVESTIGATION & RESPONSE SKIPPED",
  MarkSCExceptionSupplierCATakenAsComplete:
    "SUPPLIER CORRECTIVE ACTION(S) TAKEN MARKED AS COMPLETED",
  IsSCExceptionSupplierCATakenSkipped:
    "SUPPLIER CORRECTIVE ACTION(S) TAKEN SKIPPED",
  MarkInvestigationAsComplete: "Investigation",
  IsInvestigationSkipped: "Investigation Skipped",
  MarkConsequenceAssessmentAsComplete: "Assessment of Consequences",
  IsConsequenceAssessmentSkipped: "Consequence Assessment Skipped",
  MarkRequiredActionAsComplete: "Mark Required Action As Complete",
  MarkTakenActionAsComplete: "Immediate Action",
  IsActionTakenSkipped: "Action Skipped",
  IsRootCauseSkipped: "Root Cause Skipped",
  IsPreventativeActionSkipped: "Preventative Action Skipped",
  HasSupplierEmailSent: "SUPPLIER EMAIL SENT",
  IsResponseRequired: "Response Required?",
  HasSupplierResponded: "Supplier Responded?",
  ApprovedById: "Approved By",
  ApprovedBy: "Approved By",
  MarkRootCauseAsComplete: "Root Cause",
  MarkPreventativeActionAsComplete: "Preventative Action",
  IsNcCreatedInError: "Nc Created In Error",
  StepSequencePosition: "Step Sequence Position",
  LastModifiedByDate: "Updated date",
};

export const LabelSizeOptions = [
  {
    value: "Label60x30",
    label: "Label 60mm x 30mm",
  },
  {
    value: "Label100x60",
    label: "Label 100mm x 60mm",
  },
];

export const PrintingLabelSizeOptions = [
  {
    value: "Label60x30",
    label: "Label 60mm x 30mm",
  },
  {
    value: "Label80x60",
    label: "Label 80mm x 60mm",
  },
  {
    value: "Label80x65",
    label: "Label 80mm x 65mm",
  },
  {
    value: "Label76x51",
    label: "Label 76mm x 51mm",
  },
  {
    value: "Label101x54",
    label: "Label 101mm x 54mm",
  },
];

export const SubLocationStatus = [
  {
    value: "0",
    label: "Select Status",
  },
  {
    value: "InUse",
    label: "In Use",
  },
  {
    value: "NotInUse",
    label: "Not In Use",
  },
  {
    value: "OffSite",
    label: "Off Site",
  },
  {
    value: "Repair",
    label: "Repair",
  },
];

export const StockCheckOptions = [
  {
    value: "ALL",
    label: "ALL",
  },
  {
    value: "Customer",
    label: "CUSTOMER",
  },
  {
    value: "Supplier",
    label: "SUPPLIER",
  },
];

export const ProductByOptions = [
  {
    value: "",
    label: "Select Product By",
  },
  {
    value: "ProductCode",
    label: "Product Code",
  },
  {
    value: "ProductDescription",
    label: "Product Description",
  },
];

export const ReviewFrequency = [
  {
    value: null,
    label: "Select Frequency",
  },
  {
    value: "Daily",
    label: "Daily",
  },
  {
    value: "Weekly",
    label: "Weekly",
  },
  {
    value: "Monthly",
    label: "Monthly",
  },
  {
    value: "Yearly",
    label: "Yearly",
  },
  {
    value: "AsRequired",
    label: "As Required",
  },
];

export const UnitOfMeasurement = [
  {
    value: null,
    label: "Select Unit of Measurement",
  },
  {
    value: "g",
    label: "g",
  },
  {
    value: "kilo",
    label: "Kilo",
  },
];

export const ServiceType = [
  {
    value: null,
    label: "Select Service Type",
  },
  {
    value: "Breakdown",
    label: "Breakdown",
  },
  {
    value: "Service",
    label: "Service",
  },
  {
    value: "BreakdownAndService",
    label: "Breakdown and Service",
  },
];

export const CERTIFICATE_TYPES = [
  {
    certificateType: 22,
    certificateTypeName: "SQF Food Safety Certificate",
    classType: "SQFCE",
    entityType: "EntityId",
    settingKey: "showSQFDocument",
    temporaryClassType: "TPSQF",
  },
  {
    certificateType: 37,
    certificateTypeName: "SQF Quality Certificate",
    classType: "SQFQC",
    entityType: "EntityId",
    settingKey: "showSQFQualityCertificate",
    temporaryClassType: "TPSQQ",
  },
  {
    certificateType: 1,
    certificateTypeName: "BRCGS for Food Safety",
    classType: "BRCIM",
    entityType: "CompanyBRCImgId",
    settingKey: "showBRCCertificate",
    temporaryClassType: "TPBRC",
  },
  {
    certificateType: 41,
    certificateTypeName: "BRCGS for Packaging Materials Certificate",
    classType: "BRCPM",
    entityType: "EntityId",
    settingKey: "showBRCGSForPackagingMaterialsCertificate",
    temporaryClassType: "TPBRP",
  },
  {
    certificateType: 42,
    certificateTypeName: "BRCGS for Storage and Distribution Certificate",
    classType: "BRSDI",
    entityType: "EntityId",
    settingKey: "showBRCGSForStorageAndDistributionCertificate",
    temporaryClassType: "TPBSD",
  },
  {
    certificateType: 43,
    certificateTypeName: "BRCGS for Agents and Brokers Certificate",
    classType: "BRCPD",
    entityType: "EntityId",
    settingKey: "showBRCGSForAgentsAndBrokersCertificate",
    temporaryClassType: "TPBRD",
  },
  {
    certificateType: 13,
    certificateTypeName: "FSSC/ISO 22000",
    classType: "ISO22",
    entityType: "EntityId",
    settingKey: "showFSSCISO22000Document",
    temporaryClassType: "TPI22",
  },
  {
    certificateType: 10,
    certificateTypeName: "HACCP Certificate",
    classType: "HACCP",
    entityType: "EntityId",
    settingKey: "showHACCPCertificate",
    temporaryClassType: "TPHCP",
  },
  {
    certificateType: 33,
    certificateTypeName: "Organic Association Certificate",
    classType: "OACER",
    entityType: "EntityId",
    settingKey: "showOrganicAssociationCertificate",
    temporaryClassType: "TPOAC",
  },
  {
    certificateType: 34,
    certificateTypeName: "Public Liability Insurance Certificate",
    classType: "PLICE",
    entityType: "EntityId",
    settingKey: "showPublicLiabilityInsuranceCertificate",
    temporaryClassType: "TPPLI",
  },
  {
    certificateType: 35,
    certificateTypeName: "Products Liability Insurance Certificate",
    classType: "PRLIC",
    entityType: "EntityId",
    settingKey: "showProductsLiabilityInsuranceCertificate",
    temporaryClassType: "TPPRL",
  },
  {
    certificateType: 36,
    certificateTypeName: "Employers Liability Certificate",
    classType: "ELICE",
    entityType: "EntityId",
    settingKey: "showEmployersLiabilityCertificate",
    temporaryClassType: "TPELI",
  },
  {
    certificateType: 2,
    certificateTypeName: "RSPO",
    classType: "RSPOI",
    entityType: "CompanyRSPOImgId",
    settingKey: "showRSPODocument",
    temporaryClassType: "TPRSP",
  },
  // {
  //   certificateType: 3,
  //   certificateTypeName: "Supplier Allergen Form",
  //   classType: "SAFRM",
  //   entityType: "SupplierAllergenFormId",
  //   settingKey: "showSupplierAllergenForm",
  //   temporaryClassType: "TPSAF",
  // },
  // {
  //   certificateType: 4,
  //   certificateTypeName: "Attach Vulnerability Assessment Doc",
  //   classType: "VLDOC",
  //   entityType: "VulnerabilityDocId",
  //   settingKey: "showAttachVulnerabilityAssessmentDoc",
  //   temporaryClassType: "TPVLD",
  // },
  {
    certificateType: 5,
    certificateTypeName: "SALSA Food & Drink Production Certificate",
    classType: "CSDOC",
    entityType: "CompanySalsaDocId",
    settingKey: "showSalsaDocument",
    temporaryClassType: "TPSAL",
  },
  {
    certificateType: 38,
    certificateTypeName: "SALSA Brokers Storage Distribution Certificate",
    classType: "CSDIS",
    entityType: "EntityId",
    settingKey: "showSalsaDistributionCertificate",
    temporaryClassType: "TPSCD",
  },
  {
    certificateType: 39,
    certificateTypeName: "SALSA Plus Beer Certificate",
    classType: "CSPLU",
    entityType: "EntityId",
    settingKey: "showSalsaPlusBeerCertificate",
    temporaryClassType: "TPSPB",
  },
  {
    certificateType: 40,
    certificateTypeName: "SALSA Plus Cheese Certificate",
    classType: "CSPLF",
    entityType: "EntityId",
    settingKey: "showSalsaPlusCheeseCertificate",
    temporaryClassType: "TPSPC",
  },
  // {
  //   certificateType: 6,
  //   certificateTypeName: "COSHH Document",
  //   classType: "COSHH",
  //   entityType: "SupplierCOSHHDocumentId",
  //   settingKey: "showCOSHHDocument",
  //   temporaryClassType: "TPCSH",
  // },
  // {
  //   certificateType: 7,
  //   certificateTypeName: "Global G.A.P Document",
  //   classType: "GLGAP",
  //   entityType: "EntityId",
  //   settingKey: "showGlobalGAPDocument",
  //   temporaryClassType: "TPGAP",
  // },
  {
    certificateType: 8,
    certificateTypeName: "Red Tractor",
    classType: "RTDOC",
    entityType: "EntityId",
    settingKey: "showRedTractorDocument",
    temporaryClassType: "TPRTD",
  },
  {
    certificateType: 9,
    certificateTypeName: "LEAF Document",
    classType: "LEAFD",
    entityType: "EntityId",
    settingKey: "showLEAFDocument",
    temporaryClassType: "TPLEF",
  },
  // {
  //   certificateType: 11,
  //   certificateTypeName: "ISO 9001",
  //   classType: "ISO90",
  //   entityType: "EntityId",
  //   settingKey: "showHACCPCertificate",
  //   temporaryClassType: "TPIS9",
  // },
  // {
  //   certificateType: 12,
  //   certificateTypeName: "ISO 14001",
  //   classType: "ISO14",
  //   entityType: "EntityId",
  //   settingKey: "showHACCPCertificate",
  //   temporaryClassType: "TPI14",
  // },
  // {
  //   certificateType: 14,
  //   certificateTypeName: "GFSI",
  //   classType: "GFSIC",
  //   entityType: "EntityId",
  //   settingKey: "",
  //   temporaryClassType: "TPGFS",
  // },
  // {
  //   certificateType: 15,
  //   certificateTypeName: "Halal",
  //   classType: "HALAL",
  //   entityType: "EntityId",
  //   settingKey: "",
  //   temporaryClassType: "TPHAL",
  // },
  // {
  //   certificateType: 16,
  //   certificateTypeName: "QS",
  //   classType: "QSCER",
  //   entityType: "EntityId",
  //   settingKey: "",
  //   temporaryClassType: "TPQSC",
  // },
  // {
  //   certificateType: 17,
  //   certificateTypeName: "IFS",
  //   classType: "IFSCE",
  //   entityType: "EntityId",
  //   settingKey: "",
  //   temporaryClassType: "TPIFS",
  // },
  // {
  //   certificateType: 18,
  //   certificateTypeName: "Red TracRed Tractor Assurance C of C",
  //   classType: "RTAOC",
  //   entityType: "EntityId",
  //   settingKey: "",
  //   temporaryClassType: "TPRTA",
  // },
  // {
  //   certificateType: 19,
  //   certificateTypeName: "Organic Certificate",
  //   classType: "ORGCE",
  //   entityType: "EntityId",
  //   settingKey: "",
  //   temporaryClassType: "TPORG",
  // },
  {
    certificateType: 20,
    certificateTypeName: "Fresh Care",
    classType: "FRESH",
    entityType: "EntityId",
    settingKey: "showFreshCareDocument",
    temporaryClassType: "TPFRC",
  },
  {
    certificateType: 21,
    certificateTypeName: "HARPS",
    classType: "HARPS",
    entityType: "EntityId",
    settingKey: "showHARPSDocument",
    temporaryClassType: "TPHRP",
  },
  {
    certificateType: 23,
    certificateTypeName: "SOIL Association",
    classType: "SOILA",
    entityType: "EntityId",
    settingKey: "showSOILAssociationDocument",
    temporaryClassType: "TPSOL",
  },
  {
    certificateType: 24,
    certificateTypeName: "ISO 450001",
    classType: "ISO45",
    entityType: "EntityId",
    settingKey: "showISO450001Document",
    temporaryClassType: "TPI45",
  },
  {
    certificateType: 25,
    certificateTypeName: "RSPCA",
    classType: "RSPCA",
    entityType: "EntityId",
    settingKey: "showRSPCADocument",
    temporaryClassType: "TPRSC",
  },
  {
    certificateType: 26,
    certificateTypeName: "SMETA",
    classType: "SMETA",
    entityType: "EntityId",
    settingKey: "showSMETADocument",
    temporaryClassType: "TPSMT",
  },
  {
    certificateType: 27,
    certificateTypeName: "WSEP",
    classType: "WSEPC",
    entityType: "EntityId",
    settingKey: "showWSEPDocument",
    temporaryClassType: "TPWSP",
  },
  {
    certificateType: 28,
    certificateTypeName: "Coles",
    classType: "COLES",
    entityType: "EntityId",
    settingKey: "showColesDocument",
    temporaryClassType: "TPCOL",
  },
  {
    certificateType: 29,
    certificateTypeName: "Aldi",
    classType: "ALDIC",
    entityType: "EntityId",
    settingKey: "showAldiDocument",
    temporaryClassType: "TPALD",
  },
  {
    certificateType: 30,
    certificateTypeName: "McDonalds",
    classType: "MCDON",
    entityType: "EntityId",
    settingKey: "showMcDonaldsDocument",
    temporaryClassType: "TPMCD",
  },
  {
    certificateType: 31,
    certificateTypeName: "Costco",
    classType: "COSTC",
    entityType: "EntityId",
    settingKey: "showCostcoDocument",
    temporaryClassType: "TPCST",
  },
  {
    certificateType: 32,
    certificateTypeName: "Fair Farms",
    classType: "FAIRF",
    entityType: "EntityId",
    settingKey: "showFairFarmsDocument",
    temporaryClassType: "TPFRF",
  },
  {
    certificateType: 44,
    certificateTypeName: "Rainforest Alliance",
    classType: "RAINF",
    entityType: "EntityId",
    settingKey: "showRainforestAllianceCertificate",
    temporaryClassType: "TPRLF",
  },
  {
    certificateType: 45,
    certificateTypeName: "Kosher",
    classType: "KOSHR",
    entityType: "EntityId",
    settingKey: "showKosherCertificate",
    temporaryClassType: "TPKSH",
  }
];
